import { PRODUCT_BYLINE, PRODUCT_NAME } from "@sagot/constants";
import { SagotLogoMark } from "./brand-icons";

/**
 * Marketing lockup of the auth shell: black tile with the white Sagot mark (white tile with the black mark in the dark theme),
 * "sagot", "BY CRUD.IT" (decorative: the link carries the name).
 */
export function AuthLogo() {
  return (
    <span className="a-logo" aria-hidden="true">
      <span className="a-logo-mark">
        <SagotLogoMark />
      </span>
      <span className="a-logo-name">{PRODUCT_NAME}</span>
      <small className="a-logo-by">{PRODUCT_BYLINE}</small>
    </span>
  );
}
